<div class="row">
    <div class="col-12">

        <form [formGroup]="indovinaParolaForm">
            <aw-wizard #wizard class="arc-wizard" navBarLocation="left">

                <aw-wizard-step stepTitle="DOMANDA">
                    <div class="row">
                        <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="domanda">DOMANDA*</label>
                                    <input formControlName="domanda" type="text" class="form-control" id="domanda" aria-describedby="domanda" placeholder="">
                                    <small id="domandaHelp" class="form-text text-muted">Scrivi una domanda</small>
                                </div>
                                <div class="form-group">
                                    <label for="sottotitolo">SOTTOTITOLO</label>
                                    <textarea  formControlName="sottotitolo" class="form-control" id="sottotitolo" aria-describedby="sottotitoloHelp"></textarea>
                                    <small id="sottotitoloHelp" class="form-text text-muted">Scrivi un sottotitolo o un indicazione aggiuntiva</small>
                                </div>
                                <div class="form-group">
                                    <label for="info">INFO</label>
                                    <app-tinymce formControlName="info" id="info" aria-describedby="infoHelp"></app-tinymce>
                                    <small id="infoHelp" class="form-text text-muted">Inserisci le info della tua Interazione</small>
                                </div>
                                <h6>Coordinate:</h6>
                                <div class="form-group">
                                    <label for="lat">LATITUDINE</label>
                                    <input formControlName="lat" type="text" class="form-control" id="lat" aria-describedby="latHelp" placeholder="41.89884227456026">
                                    <small id="latHelp" class="form-text text-muted">Inserisci la latitudine</small>
                                </div>
                                <div class="form-group">
                                    <label for="lat">LONGITUDINE</label>
                                    <input formControlName="lng" type="text" class="form-control" id="lng" aria-describedby="lngHelp" placeholder="12.52539241745996">
                                    <small id="lngHelp" class="form-text text-muted">Longitudine</small>
                                </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateDomanda()" (click)="setDomanda()">Avanti</button>
                        </div>
                    </div>
                </aw-wizard-step>

                <aw-wizard-step stepTitle="RISPOSTA">

                    <div class="row">
                        <div class="col-12">
                            <label for="domanda" class="mt-0">RISPOSTA*</label>
                            <div class="form-group">
                                <label for="domanda">La Parola da comporre</label>
                                <input formControlName="parola" type="text" class="form-control" id="parola" aria-describedby="parola" [value]="interaction.interactionData?.risposta">
                                <small id="rispostaSinistraHelp" class="form-text text-muted">Scrivi la parola da indovinare.</small>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3 d-flex justify-content-end">
                            <button type="button" class="btn btn-secondary mr-2" awNextStep [disabled]="!indovinaParolaForm.valid" (click)="onAddInteraction()">Salva</button>
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!indovinaParolaForm.valid" (click)="onAddInteraction()" *ngIf="saveInExperience">Salva e aggiungi alla experience</button>
                        </div>
                    </div>
                </aw-wizard-step>
            
            </aw-wizard>
        </form>
    </div>
</div>

<!-- {{interaction | json}} -->